var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H13.5C14.3284 4 15 4.67157 15 5.5V9H14V5.5C14 5.22386 13.7761 5 13.5 5H8V4ZM5 8V13.5C5 13.7761 5.22386 14 5.5 14H9V15H5.5C4.67157 15 4 14.3284 4 13.5V8H5ZM2 3.5C2 2.67157 2.67157 2 3.5 2H5.5C6.32843 2 7 2.67157 7 3.5V5.54331C7 6.37174 6.32843 7.04331 5.5 7.04331H3.5C2.67157 7.04331 2 6.37174 2 5.54331V3.5ZM3.5 3C3.22386 3 3 3.22386 3 3.5V5.54331C3 5.81946 3.22386 6.04331 3.5 6.04331H5.5C5.77614 6.04331 6 5.81946 6 5.54331V3.5C6 3.22386 5.77614 3 5.5 3H3.5ZM10.0039 11.5C10.0039 10.6716 10.6755 10 11.5039 10H16.5039C17.3323 10 18.0039 10.6716 18.0039 11.5V16.5C18.0039 17.3284 17.3323 18 16.5039 18H11.5039C10.6755 18 10.0039 17.3284 10.0039 16.5V11.5ZM11.5039 11C11.2278 11 11.0039 11.2239 11.0039 11.5V16.5C11.0039 16.7761 11.2278 17 11.5039 17H16.5039C16.78 17 17.0039 16.7761 17.0039 16.5V11.5C17.0039 11.2239 16.78 11 16.5039 11H11.5039Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluid);
export default __webpack_public_path__ + "static/media/Fluid.8ed2e04865e939504802109926c397cc.svg";
export { ForwardRef as ReactComponent };